(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  // Search Modal Functionality
  document.addEventListener('DOMContentLoaded', function() {
    const searchToggle = document.querySelector('[data-search-toggle]');
    const searchModal = document.getElementById('search-modal');
    const searchClose = document.querySelector('[data-search-close]');
    const searchInput = document.getElementById('Search-In-Modal');

    if (searchToggle && searchModal) {
      searchToggle.addEventListener('click', function() {
        searchModal.setAttribute('open', '');
        document.body.style.overflow = 'hidden';
        setTimeout(() => {
          if (searchInput) searchInput.focus();
        }, 100);
      });
    }

    if (searchClose && searchModal) {
      searchClose.addEventListener('click', function() {
        searchModal.removeAttribute('open');
        document.body.style.overflow = '';
      });
    }

    // Close search modal when clicking outside
    if (searchModal) {
      searchModal.addEventListener('click', function(e) {
        if (e.target === searchModal) {
          searchModal.removeAttribute('open');
          document.body.style.overflow = '';
        }
      });
    }

    // Close search modal with Escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && searchModal && searchModal.hasAttribute('open')) {
        searchModal.removeAttribute('open');
        document.body.style.overflow = '';
      }
    });

    // Mobile Menu Toggle Animation
    const mobileToggle = document.querySelector('.mobile-menu-toggle');
    if (mobileToggle) {
      mobileToggle.addEventListener('click', function() {
        this.classList.toggle('active');
      });
    }
  });

  // Sticky Header Effect
  window.addEventListener('scroll', function() {
    const header = document.querySelector('.header');
    if (window.scrollY > 100) {
      header.style.transform = 'translateY(-100%)';
    } else {
      header.style.transform = 'translateY(0)';
    }
  });

  } catch(e) { console.error(e); }
})();
})();
